import { AddIcon, MinusIcon } from "@chakra-ui/icons"
import {
  ButtonGroup,
  FormControl,
  FormLabel,
  IconButton,
  Text,
} from "@chakra-ui/react"

import { CounterProps } from "./types"

function Counter(props: CounterProps) {
  const {
    name,
    value,
    decrementCounter,
    incrementCounter,
    borderColor = "#E2E8F0",
    iconWidth = "24px",
  } = props

  return (
    <FormControl
      display='flex'
      justifyContent='space-between'
      alignItems='center'
    >
      {name && <FormLabel fontSize='xl'>{name}</FormLabel>}

      <ButtonGroup spacing={4} alignItems='center'>
        <IconButton
          size='xs'
          width={iconWidth}
          height={iconWidth}
          variant='outline'
          disabled={value <= 1}
          aria-label='Subtract'
          icon={<MinusIcon color={borderColor} />}
          data-testid={`${name}dec`}
          onClick={decrementCounter}
          borderColor={borderColor}
        />

        <Text data-test={`${name}value`}>{value}</Text>

        <IconButton
          data-test={name}
          size='xs'
          width={iconWidth}
          height={iconWidth}
          variant='outline'
          disabled={value >= 10}
          data-testid={name}
          aria-label='Add'
          icon={<AddIcon color={borderColor} />}
          onClick={incrementCounter}
          borderColor={borderColor}
        />
      </ButtonGroup>
    </FormControl>
  )
}

export default Counter
